import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import * as MeetingService from 'services/agents/meeting';

export const useMeetingService = () => {
  const { token } = useSelector((store) => store.user_data);

  const createMeeting = async (data, options = {}) => {
    const { error, payload } = await MeetingService.create({ ...options, data, token });
    if (error) {
      toast.error(error || 'Unable to schedule meeting at this time.');
      return { meeting: null };
    }

    toast.success('Meeting scheduled successfully.');
    const meeting = payload?.data || payload || null;
    return { meeting };
  };

  const fetchMeetings = async (options = {}) => {
    const { error, payload } = await MeetingService.read({ ...options, token });
    if (error) {
      toast.error('Unable to fetch meetings at this time.');
      return { meetings: [], size: 0 };
    }

    const meetings = payload?.data || payload?.meetings || [];
    const size = payload?.meta?.size ?? meetings.length;
    return { meetings, size };
  };

  const updateMeeting = async (id, data, options = {}) => {
    const { error, payload } = await MeetingService.updateById(id, { ...options, data, token });
    if (error) {
      toast.error(error || 'Unable to update meeting at this time.');
      return { meeting: null };
    }

    toast.success('Meeting updated successfully.');
    const meeting = payload?.data || payload || null;
    return { meeting };
  };

  const deleteMeeting = async (id, options = {}) => {
    const { error } = await MeetingService.deleteOne(id, { ...options, token });
    if (error) {
      toast.error('Unable to delete meeting at this time.');
      return false;
    }

    toast.success('Meeting deleted successfully.');
    return true;
  };

  return { createMeeting, fetchMeetings, updateMeeting, deleteMeeting };
};
